import React, { Component } from 'react';
import { Formik } from 'formik';

import { Button, Col, Form, FormFeedback, FormGroup, Label, Input,  Row, Card, CardBody,CardHeader} from 'reactstrap';
import * as Yup from 'yup';
import { Helmet } from 'react-helmet'
import Postman from '../../utils/service'
import './index.css'
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const ValidationSchema = Yup.object().shape({
      full_name: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
      phone: Yup.string()
        .matches(phoneRegExp, 'Phone number is not valid'),
      email: Yup.string()
        .email('Invalid email')
        .required('Required'),      
      message: Yup.string()
        .min(2, 'Too Short!')
        .required('Required'),                                                 
    });

class ContactUs extends Component {

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    Postman.contactmsg(values)
            .then(res=>{
              if (res.status == 200) resetForm()
            })
  }

  render() {
    return (
      <div className="animated fadeIn mainView" style={{height:'100%'}}>
      <Helmet>
          <title>Growjo - Contact Us</title>
          <meta name="description" content="Growjo: Contact Us" />
          <meta name="author" content="Growjo"></meta>
       </Helmet>       
      <Card style={{height:'100%'}}>
        <CardHeader className='cardHeader'>
          <h1 style={{color:'#474866',fontSize:22,marginBottom:0}}>Contact Us</h1>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm={6}>
            <Formik
              initialValues={{
                full_name: '',
                phone: '',
                email: '',
                message: '',
              }}
            validationSchema={ValidationSchema}
              onSubmit={this.onSubmit}
            >
            {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched}) => (
                <Form onSubmit={handleSubmit} noValidate name='subscribeForm' style={{width:"100%"}}>
                  <FormGroup >
                    <Label>Full Name<span className="text-danger"> *</span></Label>
                    <Input type="text"
                            name="full_name"
                            id="full_name"
                            placeholder=""
                            valid={!errors.full_name&&values.full_name!=''}
                            invalid={touched.full_name && !!errors.full_name}
                            autoFocus={false}
                            onChange={handleChange}
                            required
                            value={values.full_name} />
                    <FormFeedback>{errors.full_name}</FormFeedback>
                  </FormGroup>       
                  <FormGroup >
                  <Label>Email<span className="text-danger"> *</span></Label>
                    <Input type="text"
                            name="email"
                            id="email"
                            placeholder=""
                            valid={!errors.email&&values.email!=''}
                            invalid={touched.email && !!errors.email}
                            autoFocus={false}
                            onChange={handleChange}
                            required
                            value={values.email} />
                    <FormFeedback>{errors.email}</FormFeedback>
                  </FormGroup> 
                  <FormGroup >
                  <Label>Phone Number</Label>
                    <Input type="text"
                            name="phone"
                            id="phone"
                            placeholder=""
                            valid={!errors.phone&&values.phone!=''}
                            invalid={touched.phone && !!errors.phone}
                            autoFocus={false}
                            onChange={handleChange}
                            required
                            value={values.phone} />
                    <FormFeedback>{errors.phone}</FormFeedback>
                  </FormGroup>             
                  <FormGroup >
                  <Label>Message<span className="text-danger"> *</span></Label>
                    <Input type="textarea"
                            name="message"
                            id="message"
                            placeholder=""
                            valid={!errors.message&&values.message!=''}
                            invalid={touched.message && !!errors.message}
                            autoFocus={false}
                            onChange={handleChange}
                            required
                            rows={8}
                            value={values.message} />
                    <FormFeedback>{errors.message}</FormFeedback>
                  </FormGroup> 
                  <FormGroup style={{float:"right"}}>
                    <Button 
                      style={{width: 150}}
                      type="submit" color="success" className="mr-1">Send</Button>
                  </FormGroup>   
                </Form>
              )}
              </Formik>
            </Col>
            <Col sm={6}>
              <img src = {'/static/img/location_map.png'} width={400}/>
              <div className='contactItem'>
                <img src={'/static/img/contact/location.png'}/>
                <p>
                1300 Walnut St #20<br/>
                Boulder, CO 80304
                </p> 
              </div>   
              {/* <div className='contactItem'>
                <img src={'/static/img/contact/email.png'}/>  
                <p>​tom@growjo.com</p>
              </div>              */}
              {/* <div className='contactItem'>
                <img src={'/static/img/contact/phone.png'}/>
                <p>
                505-500-2317
                </p>                
              </div> */}
            </Col>
          </Row>
        </CardBody>
      </Card>
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./client/src/views/Contact/index.js